import { render, staticRenderFns } from "./dot-info.vue?vue&type=template&id=7a7d09c2"
import script from "./dot-info.vue?vue&type=script&lang=js"
export * from "./dot-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7d09c2')) {
      api.createRecord('7a7d09c2', component.options)
    } else {
      api.reload('7a7d09c2', component.options)
    }
    module.hot.accept("./dot-info.vue?vue&type=template&id=7a7d09c2", function () {
      api.rerender('7a7d09c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dot-info.vue"
export default component.exports